/* ============================================================
   NeoSpherium · custom <select> enhancer. Progressively upgrades any
   <select data-ns-select> into the elegant NS dropdown panel (matching the
   PLP Sort + nav menus), instead of the native OS "tool box" list. The native
   <select> stays in the form (visually hidden, non-interactive) so submission,
   required-validation, and no-JS fallback all keep working.
   CSS (.ns-select*) in ns-components.css.
   ============================================================ */
(function () {
  var CARET = '<svg class="ns-select__caret" viewBox="0 0 10 6" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M1 1l4 4 4-4"></path></svg>';

  function enhance(sel) {
    if (sel.dataset.nsEnhanced) return;
    sel.dataset.nsEnhanced = '1';

    var wrap = document.createElement('div');
    wrap.className = 'ns-select';
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
    sel.classList.add('ns-select__native');
    sel.setAttribute('tabindex', '-1');
    sel.setAttribute('aria-hidden', 'true');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ns-select__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var label = document.createElement('span');
    label.className = 'ns-select__current';
    btn.appendChild(label);
    btn.insertAdjacentHTML('beforeend', CARET);

    var panel = document.createElement('ul');
    panel.className = 'ns-select__panel';
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;

    function syncLabel() {
      var o = sel.options[sel.selectedIndex];
      // data-short lets a trigger show a compact label (e.g. "KWD") while the panel keeps full names.
      label.textContent = o ? (o.getAttribute('data-short') || o.textContent) : '';
      wrap.classList.toggle('has-value', !!(sel.value && sel.value !== ''));
    }

    Array.prototype.forEach.call(sel.options, function (opt, i) {
      var li = document.createElement('li');
      li.className = 'ns-select__opt';
      li.setAttribute('role', 'option');
      li.textContent = opt.textContent;
      if (opt.value === '' || opt.disabled) li.classList.add('ns-select__opt--placeholder');
      if (i === sel.selectedIndex) li.classList.add('is-active');
      li.addEventListener('click', function () {
        sel.value = opt.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        panel.querySelectorAll('.ns-select__opt').forEach(function (x) { x.classList.remove('is-active'); });
        li.classList.add('is-active');
        syncLabel();
        close();
      });
      panel.appendChild(li);
    });

    // Optional non-interactive disclosure line at the foot of the panel (e.g. "charged in KWD").
    if (sel.getAttribute('data-ns-select-note')) {
      var noteLi = document.createElement('li');
      noteLi.className = 'ns-select__note';
      noteLi.setAttribute('role', 'presentation');
      noteLi.textContent = sel.getAttribute('data-ns-select-note');
      panel.appendChild(noteLi);
    }

    wrap.appendChild(btn);
    wrap.appendChild(panel);
    syncLabel();

    function open() { wrap.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); panel.hidden = false; }
    function close() { wrap.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); panel.hidden = true; }
    btn.addEventListener('click', function (e) { e.stopPropagation(); if (wrap.classList.contains('is-open')) close(); else open(); });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    sel.addEventListener('change', syncLabel);
  }

  function init(scope) { (scope || document).querySelectorAll('select[data-ns-select]').forEach(enhance); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
